"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUser = exports.setUser = void 0;

var corona_1 = require("corona");

var user_1 = require("../types/user");

function setUser(user) {
  return {
    type: user_1.SET_USER,
    user: user
  };
}

exports.setUser = setUser;

function getUser() {
  return function (dispatch, getState) {
    return corona_1.getCurrentUser(getState().authentication).then(function (user) {
      dispatch(setUser(user));
    });
  };
}

exports.getUser = getUser;
/*
export function loadUser(uuid: string) {
  return function (dispatch: any, getState: any) {
    let unit = new Unit(new UUID(uuid));
    unit.load();
    dispatch(setUnit(unit));
  }
}*/